import { createPermission } from '@backstage/plugin-permission-common';

export const sheriffAdminSyncPermission = createPermission({
  name: 'sheriff.admin.sync',
  attributes: {
    action: 'update',
  },
});
